// components
import Modal, { ModalFuncProps } from 'antd/es/modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'

export const showSuccessModal = (props: ModalFuncProps) =>
  Modal.success({
    className: 'modal-dialog_confirm',
    width: 350,
    title: 'Success',
    icon: <FontAwesomeIcon icon={faCheckCircle} color="#58aa43" size="3x" />,
    content: 'Successfull',
    okText: 'Ok',
    onOk: () => null,
    ...props
  })

export const showWarningModal = (props: ModalFuncProps) =>
  Modal.confirm({
    className: 'modal-dialog_confirm',
    width: 350,
    title: 'Confirm action',
    icon: (
      <FontAwesomeIcon icon={faExclamationTriangle} color="#d95f5f" size="3x" />
    ),
    content: 'Are you sure?',
    okText: 'Ok',
    onOk: () => null,
    ...props
  })

export const showInfoModal = (props: ModalFuncProps) =>
  Modal.info({
    width: 350,
    icon: null,
    ...props
  })

export const showErrorModal = (props: ModalFuncProps) =>
  Modal.error({
    className: 'modal-dialog_confirm',
    width: 350,
    title: 'Error',
    icon: <FontAwesomeIcon icon={faTimesCircle} color="#d95f5f" size="3x" />,
    ...props
  })

export const showModalCancelModal = (props: ModalFuncProps) => {
  showWarningModal({
    content: (
      <div className="display-flex display-flex-column">
        <span>Closing this window will discard all unsaved changes.</span>
        <span>Are you sure you want to proceed?</span>
      </div>
    ),
    ...props
  })
}
